import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router";
import { AdminFormPage } from "@components/CatalogIndex/AdminFormPage";
import ExpenseForm from "../ExpenseForm/ExpenseForm";

const FORM_ID = "expense-form";

function Edit({ project_id, account, permission, project }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [expense, setExpense] = useState(location.state.expense || null);

  const canSave =
    permission !== "view" &&
    permission !== "create" &&
    project?.data?.attributes?.status === "building";

  return (
    <AdminFormPage
      title={`Edit ${expense.description || "Travel & Expense"}`}
      formId={canSave ? FORM_ID : undefined}
      onCancel={() =>
        navigate(`/projects/${project_id}/project_expenses`, {
          state: null,
        })
      }
    >
      <ExpenseForm
        formId={FORM_ID}
        expenseProp={expense}
        project_id={project_id}
        account={account}
        permission={permission}
        project={project}
      />
    </AdminFormPage>
  );
}

export default Edit;
